import consola from 'consola';
import STATUS from '@/store/status';

const SET_STATUS = 'SET_STATUS';
const SET_LEFT_SWIPE_DIALOG = 'SET_LEFT_SWIPE_DIALOG';
const SET_PRD = 'SET_PRD';

// actions
const Actions = {
  SOCKET_connect() {
    // Fired when the socket connects.
    consola.info('Vuex Module: Socket connected');
    consola.info('Emitting session token to server');
    try {
      const session = localStorage.getItem('session');
      this._vm.$socket.emit('clientSessionToken', {
        data: session,
      });
    } catch (e) {
      console.log(e);
    }
  },
  SOCKET_disconnect() {
    consola.info('Vuex Module: Socket disconnected');
  },
  SOCKET_messageChannel(context, data) {
    consola.info('Vuex Module: Server sent message channel message');
    consola.info(data);
  },

  SOCKET_candidate_search_progress(context, data) {
    consola.info(
      'Vuex Module: Server sent starting candidate search progress message'
    );
    consola.info(data);

    context.commit(
      'projects/candidates/SET_PROGRESS',
      {
        projectId: data.project_id,
        progress: data.progress_pct,
        is_calibration: data.is_calibration,
      },
      { root: true }
    );
  },
  SOCKET_first_batch_fetched(context, data) {
    consola.info('Vuex Module: Server sent first batch fetched message');
    consola.info(data);

    // this.openProject(data.project_id);
    // this.currentProject.candidates_review_count += data.num_candidates_inserted;

    context.commit(
      `projects/candidates/${SET_STATUS}`,
      {
        projectId: data.project_id,
        tab: 'UNDER_REVIEW',
        status: STATUS.STALE,
      },
      { root: true }
    );

    context.dispatch(
      'projects/candidates/loadCandidates',
      {
        projectId: data.project_id,
        tab: 'UNDER_REVIEW',
        pageIdx: 0,
      },
      { root: true }
    );

    context.dispatch(
      'projects/LOAD',
      {
        force: true,
      },
      { root: true }
    );

    // Remove the progress.
    context.commit(
      'projects/candidates/SET_PROGRESS',
      {
        projectId: data.project_id,
        progress: undefined,
      },
      { root: true }
    );
  },
  SOCKET_all_candidates_fetched(context, data) {
    consola.info('Vuex Module: Server sent all candidates fetched message');
    consola.info(data);

    // this.openProject(data.project_id);
    // this.currentProject.candidates_review_count += data.num_candidates_inserted;

    context.commit(
      `projects/candidates/${SET_STATUS}`,
      {
        projectId: data.project_id,
        tab: 'UNDER_REVIEW',
        status: STATUS.STALE,
      },
      { root: true }
    );

    context.dispatch(
      'projects/candidates/loadCandidates',
      {
        projectId: data.project_id,
        tab: 'UNDER_REVIEW',
        pageIdx: 0,
      },
      { root: true }
    );

    context.dispatch(
      'projects/LOAD',
      {
        force: true,
      },
      { root: true }
    );

    // Remove the progress.
    context.commit(
      'projects/candidates/SET_PROGRESS',
      {
        projectId: data.project_id,
        progress: undefined,
      },
      { root: true }
    );
  },
  SOCKET_refresh_candidates(context, data) {
    consola.info('Vuex Module: Server sent Refresh candidates message');
    consola.info(data);

    context.commit(
      `projects/candidates/${SET_STATUS}`,
      {
        projectId: data.project_id,
        tab: 'UNDER_REVIEW',
        status: STATUS.STALE,
      },
      { root: true }
    );

    context.dispatch(
      'projects/candidates/loadCandidates',
      {
        projectId: data.project_id,
        tab: 'UNDER_REVIEW',
        pageIdx: 0,
      },
      { root: true }
    );
  },
  SOCKET_left_swipe_dialog(context, data) {
    consola.info('Vuex Module: Server sent Left swipe dialog');
    consola.info(data);

    context.commit(
      `projects/${SET_LEFT_SWIPE_DIALOG}`,
      {
        projectId: data.project_id,
      },
      { root: true }
    );
  },
  SOCKET_project_reform_dialogue(context, data) {
    consola.info('PRD');
    console.log('datadata', data);
    context.commit(
      `projects/${SET_PRD}`,
      {
        projectId: data.project_id,
        projectData: data,
      },
      {
        root: true,
      }
    );
  },
};

export default {
  namespaced: true,
  actions: Actions,
};
